// src/services/userRoleService.js

import apiClient from "./apiClient";

const API_URL = `/patient-consumables`; // Use relative path since apiClient has baseURL

export const create = async (resourceData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create`, resourceData);
  return response.data;
};

export const updateWard = async (id, wardData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.put(`${API_URL}/${id}`, wardData);
  return response.data;
};

export const getByAssignmentId = async (patientId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/by-assignment/${patientId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific patient-consumables assignment table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export const getByAdmissionId = async (admissionid) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/by-admission/${admissionid}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      console.warn(
        "Organization-specific patient-consumables table not found, returning empty array:",
        error.response.data?.message
      );
      return [];
    }
    throw error;
  }
};

export default {
  create,
  getByAssignmentId,
  getByAdmissionId 
}